import IFACE from './IFACE.js';
import Construct from '../event/Construct.js';
/** An interface for Construction driven Events
    A 'constructable' element inherits methods for creating common Elements
*/
export default class Constructable extends IFACE {
    constructor(node) {
        super(node, 'constructable');
    }
    addListeners(node) {
        node.on('construct', (ev) => node.constr(ev));
    }
    setMethods(node) {
        /** Constructs a child Element within this node
            @param {Event} ev Event
        */
        this.methods.constr = (ev) => {
            //console.log('Constructable.create', ev);
            //console.log('EVENT::construct::' + ev.detail.classname + '::' + ev.detail.caller.toString() + '::' + node.toString(), ev);
            try {
                //console.log('Constructable.create::model['+ev.detail.classname+']', ev.detail.model);
                return node.constructors[ev.detail.classname](ev.detail.model);
            }
            catch (err) {
                console.warn(node.toString() + ' is unable to construct ' + ev.detail.classname, ev.detail.model, err);
            }
        };
    }
}
export { Construct };
